import { render, staticRenderFns } from "./WhatsappImportStatusViewer.vue?vue&type=template&id=6983a83b&scoped=true"
import script from "./WhatsappImportStatusViewer.vue?vue&type=script&lang=js"
export * from "./WhatsappImportStatusViewer.vue?vue&type=script&lang=js"
import style0 from "./WhatsappImportStatusViewer.vue?vue&type=style&index=0&id=6983a83b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6983a83b",
  null
  
)

export default component.exports